






import { defineComponent } from '@vue/composition-api';

import ReceiveMaterial from '@/components/PurchaseRequest/ReceiveMaterial.vue';

const Receive = defineComponent({
  components: {
    ReceiveMaterial,
  },
  // setup() {},
});

export default Receive;
